import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  AssistanceService,
  AssistanceServiceDTO,
  AssistanceServiceHR,
} from '../../models/assistanceservice.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { RequestService } from '../request/request';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class AssistanceserviceService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'assistance-services/';
  url = environment.service_1 + 'all-assistence-services/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedAssistanceService = new BehaviorSubject<AssistanceService | null>(null);
  selectedAssistanceService$ = this.selectedAssistanceService.asObservable();

  private assistanceservices = new BehaviorSubject<AssistanceService[]>([]);
  assistanceservices$ = this.assistanceservices.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setAssistanceService(assistanceService: AssistanceService) {
    this.selectedAssistanceService.next(assistanceService);
  }

  setAssistanceServices(assistanceServices: AssistanceService[]) {
    this.assistanceservices.next(assistanceServices);
  }

  removeAssistanceServiceSelected() {
    this.selectedAssistanceService.next(null);
  }

  createAssistanceService(assistanceService: AssistanceServiceDTO) {
    return this.http.post<AssistanceService>(this.urlPath, assistanceService).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateAssistanceService(id: number, assistanceService: AssistanceServiceDTO & { id: number }) {
    return this.http.put<AssistanceService>(this.urlPath + id + '/', assistanceService).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getAssistanceService(query: QueryGet): Observable<Pagination<AssistanceService[]>> {
    return this.requestService.get<AssistanceService[]>(this.urlPath, query);
  }

  getAssistanceServiceById(id: string): Observable<AssistanceService> {
    return this.http.get<AssistanceService>(`${this.urlPath}${id}/`);
  }

  getById(id: number): Observable<AssistanceServiceHR> {
    return this.http.get<AssistanceServiceHR>(`${this.urlPath}${id}/`);
  }

  getServiceAssistanceById(id: number): Observable<AssistanceServiceHR> {
    return this.http.get<AssistanceServiceHR>(`${this.urlPath}${id}/`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getAssistanceServices(): Observable<AssistanceService[]> {
    return this.http.get<AssistanceService[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionAssistanceService(assistanceService: AssistanceService[]): OptionSelect[] {
    return assistanceService.map((item: AssistanceService) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
